import { Component } from '@angular/core';

@Component({
    selector: 'profile-status-tab2',
    template: `<div>two.............</div>`
})
export class ProfileStatusTab2Component {
   
}